import React from 'react';
import ProfileIdentity from '../shared/ProfileIdentity';

interface Props {
  number?: number;
  firstName?: string;
  lastName?: string;
  position?: string;
  profilePictureUrl?: string;
}

const PlayerSessionHeader: React.FC<Props> = ({
  number,
  firstName,
  lastName,
  position,
  profilePictureUrl,
}) => {
  return (
    <ProfileIdentity
      firstName={firstName}
      lastName={lastName}
      position={position}
      number={number}
      profilePictureUrl={profilePictureUrl}
    />
  );
};

export default PlayerSessionHeader;
